import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {CfgArClaimProcessorModel} from '../../../models/configuration/cfg-ar-claim-processor.model';
import {enumValidValueItem} from '../../ar/_models/ar.models';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {CfgArClaimProcessorForLocationsListModel} from '../../../models/configuration/cfg-ar-claim-processor-for-locations-list.model';
import {CfgArClaimProcessorForLocation} from '../../../models/configuration/cfg-ar-claim-processor-for-location';

@Injectable({
  providedIn: 'root'
})
export class ClaimsProcessorConfigurationService {
  constructor(private http: HttpClient) {
  }

  GetClaimProcessors(): Observable<CfgArClaimProcessorModel[]> {
    return this.http.get<CfgArClaimProcessorModel[]>('/api/claim-processor-configuration/get-claim-processors/');
  }

  GetClaimProcessorLocations(ClaimProcessorID: string): Observable<CfgArClaimProcessorModel[]> {
    return this.http.get<CfgArClaimProcessorModel[]>(`/api/claim-processor-configuration/get-claim-processor-locations/${ClaimProcessorID}`);
  }

  GetLocations(): Observable<ClientLocationDataModel[]> {
    return this.http.get<ClientLocationDataModel[]>('/api/claim-processor-configuration/get-locations/');
  }

  GetClaimProcessorTypes(): Observable<enumValidValueItem[]> {
    return this.http.get<enumValidValueItem[]>('/api/claim-processor-configuration/get-claim-processor-types/');
  }

  saveClaimProcessor(account: CfgArClaimProcessorModel): Observable<CfgArClaimProcessorModel> {
    return this.http.post<CfgArClaimProcessorModel>('/api/claim-processor-configuration/save-claim-processor/', account);
  }

  saveClaimProcessorLocations(ClaimProcessorID: string, account: CfgArClaimProcessorForLocation[]): Observable<number> {
    return this.http.post<number>(`/api/claim-processor-configuration/save-claim-processor-locations/${ClaimProcessorID}`, account);
  }

  removeClaimProcessor(account: CfgArClaimProcessorModel): Observable<number> {
    return this.http.post<number>('/api/claim-processor-configuration/remove-claim-processor/', account);
  }
}
